import { render, staticRenderFns } from "./myOrderDetail.vue?vue&type=template&id=08237480&scoped=true"
import script from "./myOrderDetail.vue?vue&type=script&lang=js"
export * from "./myOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./myOrderDetail.vue?vue&type=style&index=0&id=08237480&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08237480",
  null
  
)

export default component.exports